var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 769,
    viewBox: "0 0 1000 769",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.645 415.658C-28.9771 498.85 -10.5779 686.42 273.778 668.329C558.134 650.237 552.061 513.41 707.2 546.062C889.448 584.418 1069.15 344.736 973.36 145.904C879.926 -48.0714 607.641 -54.544 459.265 162.116C293.591 404.021 105.131 282.725 22.645 415.658Z",
    fill: "#F4EAC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470.202 727.791H825.454L825.454 168.895H470.202L470.202 727.791Z",
    fill: "url(#paint0_linear_942_3230)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M783.545 227.8H528.784V482.116H783.545V227.8Z",
    fill: "url(#paint1_linear_942_3230)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M783.551 227.8H740.859V482.116H783.551V227.8Z",
    fill: "url(#paint2_linear_942_3230)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M528.788 329.519C528.251 329.518 527.726 329.348 527.28 329.031C526.835 328.713 526.488 328.263 526.285 327.736C526.082 327.209 526.031 326.63 526.14 326.073C526.248 325.515 526.51 325.005 526.893 324.606L577.767 271.609C578.021 271.345 578.321 271.137 578.65 270.995C578.98 270.854 579.332 270.783 579.688 270.786C580.043 270.789 580.395 270.867 580.722 271.014C581.049 271.161 581.346 271.374 581.595 271.643C581.844 271.912 582.041 272.229 582.174 272.579C582.308 272.928 582.375 273.301 582.372 273.678C582.369 274.055 582.296 274.427 582.157 274.774C582.018 275.121 581.817 275.435 581.563 275.699L530.689 328.696C530.182 329.225 529.499 329.521 528.788 329.519Z",
    fill: "url(#paint3_linear_942_3230)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M783.554 329.132C783.017 329.131 782.492 328.962 782.046 328.644C781.6 328.327 781.254 327.876 781.051 327.349C780.848 326.822 780.797 326.243 780.905 325.686C781.013 325.129 781.276 324.618 781.659 324.219L832.18 271.591C832.433 271.327 832.733 271.118 833.062 270.977C833.392 270.836 833.745 270.765 834.1 270.768C834.455 270.771 834.807 270.848 835.134 270.995C835.461 271.142 835.758 271.356 836.007 271.625C836.256 271.893 836.453 272.211 836.587 272.56C836.72 272.91 836.787 273.283 836.784 273.66C836.781 274.036 836.708 274.409 836.569 274.756C836.431 275.102 836.229 275.417 835.975 275.681L785.448 328.291C784.946 328.825 784.265 329.128 783.554 329.132Z",
    fill: "url(#paint4_linear_942_3230)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M560.759 436.887H557.798V426.785L560.759 428.511V436.887Z",
    fill: "url(#paint5_linear_942_3230)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M535.891 433.375H532.275V421.05L535.891 423.156V433.375Z",
    fill: "url(#paint6_linear_942_3230)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M541.962 434.615V435.573C541.962 436.308 541.687 437.012 541.197 437.532C540.706 438.051 540.042 438.343 539.349 438.343H528.784V431.846H539.349C540.042 431.846 540.706 432.137 541.197 432.657C541.687 433.176 541.962 433.881 541.962 434.615Z",
    fill: "url(#paint7_linear_942_3230)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M563.231 435.629H555.332C553.943 435.629 552.817 436.821 552.817 438.291C552.817 439.761 553.943 440.953 555.332 440.953H563.231C564.62 440.953 565.746 439.761 565.746 438.291C565.746 436.821 564.62 435.629 563.231 435.629Z",
    fill: "url(#paint8_linear_942_3230)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M545.984 440.855V482.116H528.784V435.524H540.954C542.288 435.524 543.567 436.086 544.511 437.085C545.454 438.085 545.984 439.441 545.984 440.855Z",
    fill: "url(#paint9_linear_942_3230)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M554.91 438.65H563.655C564.362 438.649 565.063 438.796 565.717 439.082C566.37 439.369 566.965 439.789 567.465 440.319C567.966 440.848 568.363 441.478 568.634 442.17C568.905 442.863 569.044 443.605 569.044 444.355V482.116H549.526V444.355C549.526 442.842 550.094 441.391 551.103 440.321C552.113 439.251 553.482 438.65 554.91 438.65Z",
    fill: "url(#paint10_linear_942_3230)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M470.489 728.068H250.713V168.588H470.489V728.068ZM251.292 727.454H469.91V169.202H251.292V727.454Z",
    fill: "#F59192"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M470.203 168.895H251.006V727.792H470.203V168.895Z",
    fill: "url(#paint11_linear_942_3230)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M461.635 265.53H447.379C443.555 265.53 440.454 268.815 440.454 272.868V274.606C440.454 278.659 443.555 281.945 447.379 281.945H461.635C465.46 281.945 468.56 278.659 468.56 274.606V272.868C468.56 268.815 465.46 265.53 461.635 265.53Z",
    fill: "url(#paint12_linear_942_3230)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M398.841 333.744C430.116 333.744 455.47 306.876 455.47 273.734C455.47 240.592 430.116 213.724 398.841 213.724C367.566 213.724 342.212 240.592 342.212 273.734C342.212 306.876 367.566 333.744 398.841 333.744Z",
    fill: "url(#paint13_linear_942_3230)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M470.202 727.791H825.454V551.036H470.202V727.791Z",
    fill: "url(#paint14_linear_942_3230)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M470.203 551.036H251.006V727.792H470.203V551.036Z",
    fill: "url(#paint15_linear_942_3230)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M873.476 75.675H202.974V188.866H873.476V75.675Z",
    fill: "url(#paint16_linear_942_3230)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M771.396 172.119C810.215 172.119 841.684 138.772 841.684 97.6355C841.684 56.4991 810.215 23.1516 771.396 23.1516C732.577 23.1516 701.108 56.4991 701.108 97.6355C701.108 138.772 732.577 172.119 771.396 172.119Z",
    fill: "url(#paint17_linear_942_3230)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M470.194 75.675H202.974V188.866H470.194V75.675Z",
    fill: "url(#paint18_linear_942_3230)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M321.083 706.396L335.912 711.192L322.033 717.548C321.702 717.7 321.405 717.923 321.16 718.203C320.914 718.483 320.727 718.814 320.609 719.175C320.491 719.536 320.446 719.919 320.476 720.3C320.505 720.681 320.609 721.051 320.781 721.386L338.346 755.702C338.48 755.953 338.55 756.237 338.547 756.526C338.545 756.815 338.472 757.098 338.334 757.346C338.196 757.595 337.998 757.801 337.761 757.944C337.525 758.086 337.257 758.16 336.984 758.158H322.56C322.219 758.158 321.892 758.015 321.651 757.759C321.409 757.503 321.274 757.157 321.274 756.795C321.274 756.434 321.409 756.087 321.651 755.831C321.892 755.576 322.219 755.432 322.56 755.432H332.122C332.397 755.431 332.666 755.353 332.903 755.206C333.14 755.059 333.336 754.848 333.471 754.595C333.606 754.341 333.675 754.055 333.671 753.764C333.667 753.473 333.591 753.188 333.449 752.939L312.437 715.958L321.083 706.396Z",
    fill: "url(#paint19_linear_942_3230)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M305.567 718.556L315.807 708.116H326.175L311.015 719.943C310.495 720.349 310.134 720.943 310.002 721.613C309.869 722.282 309.974 722.98 310.296 723.573L333.395 766.007C333.551 766.293 333.633 766.616 333.633 766.946C333.633 767.276 333.551 767.6 333.395 767.886C333.24 768.172 333.016 768.409 332.746 768.574C332.477 768.739 332.171 768.826 331.86 768.826H317.899C317.558 768.826 317.231 768.682 316.99 768.426C316.748 768.171 316.613 767.824 316.613 767.462C316.613 767.101 316.748 766.754 316.99 766.498C317.231 766.243 317.558 766.099 317.899 766.099H327.067C327.381 766.099 327.69 766.01 327.961 765.843C328.232 765.675 328.456 765.434 328.611 765.144C328.765 764.854 328.844 764.526 328.84 764.193C328.835 763.86 328.748 763.535 328.585 763.25L305.133 721.976C304.831 721.437 304.71 720.806 304.789 720.186C304.868 719.565 305.142 718.991 305.567 718.556Z",
    fill: "url(#paint20_linear_942_3230)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.322 768.844C194.186 768.844 218.396 743.189 218.396 711.543C218.396 679.896 194.186 654.241 164.322 654.241C134.459 654.241 110.249 679.896 110.249 711.543C110.249 743.189 134.459 768.844 164.322 768.844Z",
    fill: "url(#paint21_linear_942_3230)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.325 744.833C181.675 744.833 195.74 729.928 195.74 711.543C195.74 693.157 181.675 678.252 164.325 678.252C146.975 678.252 132.91 693.157 132.91 711.543C132.91 729.928 146.975 744.833 164.325 744.833Z",
    fill: "url(#paint22_linear_942_3230)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M164.324 728.523C173.173 728.523 180.347 720.92 180.347 711.543C180.347 702.165 173.173 694.563 164.324 694.563C155.475 694.563 148.301 702.165 148.301 711.543C148.301 720.92 155.475 728.523 164.324 728.523Z",
    fill: "url(#paint23_linear_942_3230)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M476.525 768.844C506.388 768.844 530.598 743.189 530.598 711.543C530.598 679.896 506.388 654.241 476.525 654.241C446.661 654.241 422.451 679.896 422.451 711.543C422.451 743.189 446.661 768.844 476.525 768.844Z",
    fill: "url(#paint24_linear_942_3230)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M476.522 744.833C493.872 744.833 507.937 729.928 507.937 711.543C507.937 693.157 493.872 678.252 476.522 678.252C459.172 678.252 445.107 693.157 445.107 711.543C445.107 729.928 459.172 744.833 476.522 744.833Z",
    fill: "url(#paint25_linear_942_3230)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M476.521 728.523C485.371 728.523 492.545 720.92 492.545 711.543C492.545 702.165 485.371 694.563 476.521 694.563C467.672 694.563 460.498 702.165 460.498 711.543C460.498 720.92 467.672 728.523 476.521 728.523Z",
    fill: "url(#paint26_linear_942_3230)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.755 561.767L72.9883 565.053L129.795 638.158L133.562 634.871L76.755 561.767Z",
    fill: "url(#paint27_linear_942_3230)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.671 488.871H57.915V582.643H148.671V488.871Z",
    fill: "url(#paint28_linear_942_3230)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9555 579.966H157.425V585.849H51.9555C51.591 585.849 51.23 585.773 50.8932 585.625C50.5565 585.477 50.2505 585.261 49.9927 584.988C49.7349 584.715 49.5305 584.39 49.391 584.033C49.2515 583.676 49.1797 583.294 49.1797 582.908C49.1797 582.521 49.2515 582.139 49.391 581.782C49.5305 581.425 49.7349 581.101 49.9927 580.828C50.2505 580.555 50.5565 580.338 50.8932 580.19C51.23 580.042 51.591 579.966 51.9555 579.966Z",
    fill: "url(#paint29_linear_942_3230)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M410.474 518.753C420.157 520.896 427.928 516.045 428.571 502.283C429.215 488.521 423.675 484.799 415.37 484.689L410.474 518.753Z",
    fill: "url(#paint30_linear_942_3230)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M459.268 635.094C459.268 635.094 454.255 640.16 447.347 647.376C436.284 658.872 420.348 675.802 412.27 686.064C399.144 702.712 380.038 711.033 365.04 711.033C350.043 711.033 243.374 712.261 238.338 711.033C236.455 710.566 232.004 707.349 227.177 703.498C219.064 697.044 209.861 688.803 209.861 688.803H90.4199C114.962 624.04 154.536 606.108 155.504 604.131C156.472 602.154 158.28 592.021 158.28 592.021L161.484 588.171L169.14 585.899L296.787 589.583V601.755C296.787 604.5 295.431 604.499 284.808 611.433C284.234 611.81 283.688 612.233 283.174 612.698L282.873 612.986C273.919 621.584 272.135 644.526 276.295 655.912C280.746 668.077 289.259 675.661 297.407 678.67C305.554 681.679 310.498 680.371 314.942 680.371C319.387 680.371 316.791 682.214 335.434 682.214C354.076 682.214 358.365 683.614 374.388 675.913C393.094 666.929 406.666 635.475 408.19 627.534C408.192 627.522 408.192 627.51 408.19 627.497C409.68 619.6 409.013 606.919 407.883 602.319C406.753 597.72 388.516 543.532 384.767 532.589C381.017 521.646 380.658 514.841 380.658 514.841L378.705 504.445C392.781 490.241 400.9 484.634 404.203 483.436C407.506 482.239 416.071 481.748 417.306 481.748C418.54 481.748 420.029 484.204 420.644 485.831C421.258 487.459 422.44 498.426 420.899 504.831C419.566 510.358 414.994 519.637 413.759 521.056C412.525 522.475 406.805 521.437 406.26 521.437C405.716 521.437 402.557 523.942 402.557 523.942C403.366 529.105 404.786 534.139 406.782 538.926C406.783 538.951 406.783 538.975 406.782 539C414.171 557.275 428.351 575.913 435.311 585.905C444.218 598.696 449.607 599.2 452.661 607.889C455.715 616.579 459.268 635.094 459.268 635.094Z",
    fill: "url(#paint31_linear_942_3230)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M408.187 627.503C408.054 628.504 404.901 651.042 390.124 669.95C375.492 688.674 347.942 689.767 318.886 689.767C289.829 689.767 276.281 679.941 270.208 659.062C264.204 638.404 272.966 622.179 282.864 612.956C273.911 621.553 272.126 644.495 276.286 655.881C280.737 668.046 289.25 675.63 297.398 678.639C305.546 681.648 310.489 680.34 314.934 680.34C319.378 680.34 316.782 682.183 335.425 682.183C354.067 682.183 358.356 683.583 374.379 675.882C393.085 666.898 406.657 635.444 408.187 627.503Z",
    fill: "url(#paint32_linear_942_3230)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M459.268 635.094C459.268 635.094 454.256 640.16 447.348 647.376C436.285 658.872 420.349 675.802 412.271 686.064C399.145 702.712 380.039 711.033 365.041 711.033C350.044 711.033 243.375 712.261 238.339 711.033C236.456 710.566 232.005 707.349 227.178 703.498C260.737 702.982 359.304 701.453 368.849 701.097C380.398 700.667 392.348 697.443 410.185 663.944C428.022 630.445 428.091 616.29 424.371 601.245C419.399 581.121 404.917 577.252 399.852 553.996C395.065 532.005 402.547 523.979 402.547 523.979C403.362 529.13 404.785 534.152 406.783 538.926C406.784 538.951 406.784 538.975 406.783 539C414.172 557.275 428.352 575.913 435.312 585.905C444.219 598.696 449.608 599.2 452.662 607.889C455.716 616.579 459.268 635.094 459.268 635.094Z",
    fill: "url(#paint33_linear_942_3230)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M459.264 635.094C459.264 635.094 454.252 640.16 447.344 647.376L433.436 645.429C447.454 621.516 437.307 610.069 426.824 587.348C416.671 565.339 407.399 540.547 406.831 539.025C414.22 557.3 428.4 575.938 435.36 585.929C444.267 598.721 449.656 599.224 452.71 607.914C455.764 616.603 459.264 635.094 459.264 635.094Z",
    fill: "url(#paint34_linear_942_3230)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9648 695.693C98.9648 695.239 111.453 650.446 149.196 626.024C193.551 597.327 255.355 614.724 255.355 653.044C255.355 688.662 226.896 695.718 226.896 695.718L98.9648 695.693Z",
    fill: "url(#paint35_linear_942_3230)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.552 554.929C146.696 549.083 151.564 548.788 155.424 549.402C159.283 550.016 179.149 552.522 207.289 554.567C235.43 556.612 281.135 560.511 288.489 560.413C295.843 560.315 303.017 560.898 303.017 570.852C303.017 580.807 300.352 592.002 295.571 592.002H158.281C157.637 588.466 156.004 585.218 153.593 582.68C149.635 578.621 146.076 574.543 146.552 554.929Z",
    fill: "url(#paint36_linear_942_3230)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M398.843 324.852C425.484 324.852 447.081 301.965 447.081 273.734C447.081 245.503 425.484 222.617 398.843 222.617C372.202 222.617 350.605 245.503 350.605 273.734C350.605 301.965 372.202 324.852 398.843 324.852Z",
    fill: "url(#paint37_linear_942_3230)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M417.506 270.295H380.169C379.705 270.295 379.247 270.182 378.831 269.965C378.414 269.749 378.05 269.434 377.766 269.045C377.482 268.656 377.285 268.204 377.192 267.722C377.098 267.241 377.109 266.743 377.225 266.267C378.55 261.273 381.378 256.875 385.28 253.742C389.181 250.609 393.943 248.914 398.838 248.914C403.733 248.914 408.494 250.609 412.396 253.742C416.297 256.875 419.126 261.273 420.45 266.267C420.566 266.743 420.577 267.241 420.484 267.722C420.39 268.204 420.194 268.656 419.91 269.045C419.625 269.434 419.261 269.749 418.845 269.965C418.428 270.182 417.97 270.295 417.506 270.295Z",
    fill: "url(#paint38_linear_942_3230)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M419.613 273.746H378.074C375.734 273.746 373.838 275.756 373.838 278.235C373.838 280.715 375.734 282.724 378.074 282.724H419.613C421.952 282.724 423.849 280.715 423.849 278.235C423.849 275.756 421.952 273.746 419.613 273.746Z",
    fill: "url(#paint39_linear_942_3230)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M378.384 286.17H419.331C419.331 289.461 418.098 292.618 415.901 294.945C413.705 297.273 410.726 298.581 407.62 298.581H390.078C386.975 298.576 384.001 297.266 381.808 294.939C379.615 292.612 378.384 289.458 378.384 286.17Z",
    fill: "url(#paint40_linear_942_3230)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M402.393 252.142C402.393 252.142 408.188 254.838 406.617 256.208C405.047 257.577 402.393 252.142 402.393 252.142Z",
    fill: "url(#paint41_linear_942_3230)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M395.286 252.142C395.286 252.142 389.49 254.838 391.061 256.208C392.631 257.577 395.286 252.142 395.286 252.142Z",
    fill: "url(#paint42_linear_942_3230)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M398.837 251.989C398.837 251.989 395.082 259.075 398.837 259.118H398.872C402.592 259.075 398.843 251.97 398.837 251.989Z",
    fill: "url(#paint43_linear_942_3230)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M817.74 97.6359C817.895 104.189 816.81 110.708 814.551 116.81C812.291 122.912 808.902 128.473 804.583 133.166C800.264 137.858 795.103 141.587 789.403 144.134C783.703 146.68 777.58 147.992 771.394 147.992C765.209 147.992 759.086 146.68 753.386 144.134C747.686 141.587 742.525 137.858 738.206 133.166C733.887 128.473 730.498 122.912 728.238 116.81C725.978 110.708 724.894 104.189 725.049 97.6359C725.049 96.727 725.072 95.8243 725.118 94.9277C725.875 82.4699 731.079 70.7847 739.673 62.2461C748.266 53.7074 759.605 48.9558 771.386 48.9566C783.166 48.9574 794.504 53.7105 803.097 62.2503C811.689 70.7901 816.892 82.4759 817.647 94.9338C817.709 95.8263 817.74 96.727 817.74 97.6359Z",
    fill: "url(#paint44_linear_942_3230)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M817.74 97.6355C817.895 104.188 816.81 110.708 814.551 116.81C812.291 122.912 808.902 128.473 804.583 133.165C800.264 137.858 795.103 141.587 789.403 144.133C783.703 146.68 777.58 147.991 771.394 147.991C765.209 147.991 759.086 146.68 753.386 144.133C747.686 141.587 742.525 137.858 738.206 133.165C733.887 128.473 730.498 122.912 728.238 116.81C725.978 110.708 724.894 104.188 725.049 97.6355C725.049 96.7267 725.072 95.824 725.118 94.9274H817.647C817.709 95.824 817.74 96.7267 817.74 97.6355Z",
    fill: "url(#paint45_linear_942_3230)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M812.961 107.528H729.831C726.621 107.528 724.019 110.286 724.019 113.688V113.694C724.019 117.096 726.621 119.853 729.831 119.853H812.961C816.171 119.853 818.773 117.096 818.773 113.694V113.688C818.773 110.286 816.171 107.528 812.961 107.528Z",
    fill: "url(#paint46_linear_942_3230)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M815.746 90.1373H727.053C723.603 90.1373 720.806 93.1012 720.806 96.7573V96.7634C720.806 100.42 723.603 103.383 727.053 103.383H815.746C819.196 103.383 821.993 100.42 821.993 96.7634V96.7573C821.993 93.1012 819.196 90.1373 815.746 90.1373Z",
    fill: "url(#paint47_linear_942_3230)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M816.14 102.794C808.746 102.794 809.366 96.8062 803.391 96.8062C797.016 96.8062 797.016 102.849 790.601 102.849C784.186 102.849 784.227 96.8062 777.817 96.8062C771.408 96.8062 771.443 102.849 765.034 102.849C758.624 102.849 758.659 96.8062 752.25 96.8062C745.841 96.8062 745.875 102.849 739.466 102.849C733.323 102.849 732.715 96.536 727.059 96.7693H726.821C723.744 96.7693 720.835 99.4161 720.835 102.683C720.835 105.95 722.469 108.591 726.729 108.591C733.445 108.591 733.52 114.572 739.478 114.572C745.852 114.572 745.852 108.529 752.261 108.529C758.671 108.529 758.636 114.572 765.045 114.572C771.455 114.572 771.42 108.529 777.835 108.529C784.25 108.529 784.209 114.572 790.619 114.572C797.028 114.572 796.993 108.529 803.403 108.529C809.539 108.529 810.154 114.848 815.81 114.609H816.047C819.124 114.609 821.923 111.931 821.923 108.664C821.923 105.397 820.399 102.794 816.14 102.794Z",
    fill: "url(#paint48_linear_942_3230)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M853.634 482.116H507.873C504.679 482.116 502.09 484.86 502.09 488.245V492.279C502.09 495.664 504.679 498.408 507.873 498.408H853.634C856.828 498.408 859.417 495.664 859.417 492.279V488.245C859.417 484.86 856.828 482.116 853.634 482.116Z",
    fill: "url(#paint49_linear_942_3230)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M507.875 482.116H611.148V498.396H507.875C506.338 498.396 504.864 497.749 503.777 496.597C502.691 495.445 502.08 493.884 502.08 492.255V488.22C502.089 486.598 502.704 485.045 503.79 483.902C504.875 482.758 506.344 482.116 507.875 482.116Z",
    fill: "url(#paint50_linear_942_3230)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M616.422 276.854H528.784V227.8H591.95C597.922 227.8 603.65 230.314 607.874 234.789C612.097 239.265 614.469 245.334 614.469 251.664V270.148C614.456 272.543 615.137 274.884 616.422 276.854Z",
    fill: "url(#paint51_linear_942_3230)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M724.626 482.116H672.842L688.112 405.74C688.586 403.37 689.814 401.245 691.591 399.72C693.367 398.195 695.584 397.363 697.871 397.364H741.577L724.626 482.116Z",
    fill: "url(#paint52_linear_942_3230)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M721.817 482.116H773.601L750.027 405.452C749.304 403.101 747.898 401.052 746.01 399.599C744.122 398.147 741.848 397.364 739.515 397.364H695.757L721.817 482.116Z",
    fill: "url(#paint53_linear_942_3230)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M741.031 416.579H716.46C716.23 416.579 716.008 416.482 715.845 416.309C715.682 416.137 715.591 415.902 715.591 415.658C715.591 415.414 715.682 415.179 715.845 415.007C716.008 414.834 716.23 414.737 716.46 414.737H741.031C741.262 414.737 741.483 414.834 741.646 415.007C741.809 415.179 741.9 415.414 741.9 415.658C741.9 415.902 741.809 416.137 741.646 416.309C741.483 416.482 741.262 416.579 741.031 416.579Z",
    fill: "#C5E0E2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M750.141 429.776H742.173C741.942 429.776 741.721 429.679 741.558 429.506C741.395 429.334 741.304 429.099 741.304 428.855C741.304 428.611 741.395 428.377 741.558 428.204C741.721 428.031 741.942 427.934 742.173 427.934H750.141C750.372 427.934 750.593 428.031 750.756 428.204C750.919 428.377 751.01 428.611 751.01 428.855C751.01 429.099 750.919 429.334 750.756 429.506C750.593 429.679 750.372 429.776 750.141 429.776Z",
    fill: "#C5E0E2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M734.318 429.776H711.88C711.649 429.776 711.428 429.679 711.265 429.506C711.102 429.334 711.011 429.099 711.011 428.855C711.011 428.611 711.102 428.377 711.265 428.204C711.428 428.031 711.649 427.934 711.88 427.934H734.318C734.549 427.934 734.77 428.031 734.933 428.204C735.096 428.377 735.188 428.611 735.188 428.855C735.188 429.099 735.096 429.334 734.933 429.506C734.77 429.679 734.549 429.776 734.318 429.776Z",
    fill: "#C5E0E2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M753.447 439.645H745.479C745.248 439.645 745.027 439.548 744.864 439.375C744.701 439.202 744.609 438.968 744.609 438.724C744.609 438.479 744.701 438.245 744.864 438.072C745.027 437.899 745.248 437.802 745.479 437.802H753.447C753.677 437.802 753.898 437.899 754.061 438.072C754.224 438.245 754.316 438.479 754.316 438.724C754.316 438.968 754.224 439.202 754.061 439.375C753.898 439.548 753.677 439.645 753.447 439.645Z",
    fill: "#C5E0E2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M737.629 439.645H715.191C714.96 439.645 714.739 439.548 714.576 439.375C714.413 439.202 714.321 438.968 714.321 438.724C714.321 438.479 714.413 438.245 714.576 438.072C714.739 437.899 714.96 437.802 715.191 437.802H737.629C737.859 437.802 738.081 437.899 738.244 438.072C738.407 438.245 738.498 438.479 738.498 438.724C738.498 438.968 738.407 439.202 738.244 439.375C738.081 439.548 737.859 439.645 737.629 439.645Z",
    fill: "#C5E0E2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M756.757 449.513H748.789C748.559 449.513 748.338 449.416 748.175 449.244C748.011 449.071 747.92 448.837 747.92 448.592C747.92 448.348 748.011 448.114 748.175 447.941C748.338 447.768 748.559 447.671 748.789 447.671H756.757C756.988 447.671 757.209 447.768 757.372 447.941C757.535 448.114 757.627 448.348 757.627 448.592C757.627 448.837 757.535 449.071 757.372 449.244C757.209 449.416 756.988 449.513 756.757 449.513Z",
    fill: "#C5E0E2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M740.939 449.513H718.501C718.271 449.513 718.049 449.416 717.886 449.244C717.723 449.071 717.632 448.837 717.632 448.592C717.632 448.348 717.723 448.114 717.886 447.941C718.049 447.768 718.271 447.671 718.501 447.671H740.939C741.17 447.671 741.391 447.768 741.554 447.941C741.717 448.114 741.809 448.348 741.809 448.592C741.809 448.837 741.717 449.071 741.554 449.244C741.391 449.416 741.17 449.513 740.939 449.513Z",
    fill: "#C5E0E2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M760.068 459.382H752.1C751.869 459.382 751.648 459.285 751.485 459.112C751.322 458.939 751.23 458.705 751.23 458.461C751.23 458.216 751.322 457.982 751.485 457.809C751.648 457.636 751.869 457.539 752.1 457.539H760.068C760.298 457.539 760.52 457.636 760.683 457.809C760.846 457.982 760.937 458.216 760.937 458.461C760.937 458.705 760.846 458.939 760.683 459.112C760.52 459.285 760.298 459.382 760.068 459.382Z",
    fill: "#C5E0E2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M744.245 459.382H721.807C721.576 459.382 721.355 459.285 721.192 459.112C721.029 458.939 720.938 458.705 720.938 458.461C720.938 458.216 721.029 457.982 721.192 457.809C721.355 457.636 721.576 457.539 721.807 457.539H744.245C744.476 457.539 744.697 457.636 744.86 457.809C745.023 457.982 745.114 458.216 745.114 458.461C745.114 458.705 745.023 458.939 744.86 459.112C744.697 459.285 744.476 459.382 744.245 459.382Z",
    fill: "#C5E0E2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M147.024 470.049H59.5658C56.9606 470.049 54.8486 472.287 54.8486 475.048V490.271C54.8486 493.032 56.9606 495.27 59.5658 495.27H147.024C149.63 495.27 151.741 493.032 151.741 490.271V475.048C151.741 472.287 149.63 470.049 147.024 470.049Z",
    fill: "url(#paint54_linear_942_3230)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M126.517 534.689C126.521 539.543 125.17 544.29 122.635 548.333C120.099 552.376 116.492 555.534 112.267 557.41C110.937 558.001 109.558 558.457 108.147 558.773C104.901 559.517 101.542 559.517 98.2955 558.773C96.8866 558.444 95.5093 557.977 94.1811 557.379C90.3202 555.636 86.9772 552.816 84.5074 549.22C82.0375 545.624 80.533 541.386 80.1537 536.957C79.7744 532.528 80.5344 528.072 82.353 524.064C84.1717 520.056 86.981 516.644 90.4826 514.192C93.9841 511.74 98.0471 510.339 102.24 510.138C106.432 509.937 110.598 510.943 114.295 513.049C117.991 515.156 121.08 518.284 123.233 522.102C125.386 525.92 126.523 530.284 126.523 534.732L126.517 534.689Z",
    fill: "url(#paint55_linear_942_3230)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M101.164 526.257V536.323C101.165 536.852 101.087 537.379 100.932 537.882C100.727 538.588 100.383 539.24 99.9221 539.795C99.4616 540.35 98.8954 540.794 98.2607 541.1C98.0354 541.204 97.8441 541.375 97.711 541.594C97.5779 541.813 97.5091 542.068 97.5132 542.328L98.2897 558.713C96.8808 558.383 95.5035 557.916 94.1753 557.319L94.8823 542.328C94.8875 542.067 94.8184 541.81 94.684 541.591C94.5497 541.372 94.3563 541.201 94.1289 541.1C93.4963 540.794 92.9315 540.351 92.4712 539.799C92.0109 539.246 91.6655 538.598 91.4574 537.895C91.3029 537.391 91.2247 536.864 91.2256 536.335V526.27C91.2256 526.042 91.3111 525.823 91.4632 525.662C91.6154 525.501 91.8217 525.41 92.0369 525.41C92.2521 525.41 92.4584 525.501 92.6106 525.662C92.7627 525.823 92.8482 526.042 92.8482 526.27V534.591C92.8482 534.948 92.9822 535.291 93.2208 535.544C93.4593 535.797 93.7828 535.939 94.1202 535.939C94.4576 535.939 94.7811 535.797 95.0196 535.544C95.2582 535.291 95.3922 534.948 95.3922 534.591V527.793C95.3922 527.565 95.4777 527.346 95.6298 527.185C95.782 527.024 95.9883 526.933 96.2035 526.933C96.4187 526.933 96.625 527.024 96.7772 527.185C96.9293 527.346 97.0148 527.565 97.0148 527.793V534.591C97.0148 534.946 97.1477 535.288 97.3845 535.54C97.6212 535.792 97.9425 535.934 98.2781 535.936C98.4139 535.935 98.5488 535.912 98.678 535.868C98.9307 535.78 99.1508 535.61 99.3069 535.382C99.463 535.153 99.5471 534.879 99.5472 534.597V526.276C99.5472 526.048 99.6327 525.829 99.7849 525.668C99.937 525.507 100.143 525.416 100.359 525.416C100.574 525.416 100.78 525.507 100.932 525.668C101.084 525.829 101.17 526.048 101.17 526.276L101.164 526.257Z",
    fill: "url(#paint56_linear_942_3230)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M115.365 533.448C115.365 536.881 114.206 539.847 112.467 541.254C112.185 541.476 111.957 541.767 111.804 542.103C111.65 542.439 111.576 542.809 111.586 543.182L112.264 557.398C110.934 557.989 109.555 558.445 108.144 558.761L108.88 543.182C108.893 542.809 108.82 542.439 108.667 542.103C108.515 541.767 108.288 541.476 108.005 541.254C106.301 539.847 105.107 536.881 105.107 533.448C105.107 528.646 107.396 524.759 110.219 524.759C113.041 524.759 115.365 528.646 115.365 533.448Z",
    fill: "url(#paint57_linear_942_3230)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M311.162 692.002V681.237C311.162 679.339 312.698 678.259 315.381 678.259H364.204C366.522 678.259 366.568 679.548 366.568 688.483C366.563 688.483 334.673 699.113 311.162 692.002Z",
    fill: "url(#paint58_linear_942_3230)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M197.981 662.777H155.527C154.33 662.777 153.359 663.804 153.359 665.071C153.359 666.337 154.33 667.364 155.527 667.364H197.981C199.178 667.364 200.148 666.337 200.148 665.071C200.148 663.804 199.178 662.777 197.981 662.777Z",
    fill: "url(#paint59_linear_942_3230)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M193.435 670.613H150.981C149.784 670.613 148.813 671.64 148.813 672.907C148.813 674.173 149.784 675.2 150.981 675.2H193.435C194.632 675.2 195.603 674.173 195.603 672.907C195.603 671.64 194.632 670.613 193.435 670.613Z",
    fill: "url(#paint60_linear_942_3230)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M188.894 678.443H146.44C145.243 678.443 144.272 679.47 144.272 680.736C144.272 682.003 145.243 683.03 146.44 683.03H188.894C190.091 683.03 191.061 682.003 191.061 680.736C191.061 679.47 190.091 678.443 188.894 678.443Z",
    fill: "url(#paint61_linear_942_3230)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M405.684 707.625C405.684 707.625 427.542 708.116 461.316 690.123C495.089 672.13 516.305 666.29 527.223 667.193C522.453 639.411 483.349 620.472 451.447 632.938C409.363 649.396 405.684 707.625 405.684 707.625Z",
    fill: "url(#paint62_linear_942_3230)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M381.488 513.877C383.632 517.168 388.738 518.108 392.36 514.896C395.981 511.684 396.022 499.046 389.81 497.167C383.598 495.288 379.419 498.751 379.564 505.414C379.709 512.077 381.488 513.877 381.488 513.877Z",
    fill: "url(#paint63_linear_942_3230)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M370.088 508.381C370.088 508.381 380.136 502.706 382.257 501.466C387.131 498.653 392.897 509.357 388.418 512.704C384.633 515.529 375.964 520.362 375.964 520.362L370.088 508.381Z",
    fill: "url(#paint64_linear_942_3230)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M379.14 514.724C379.358 510.946 376.785 507.705 373.392 507.485C370 507.265 367.073 510.15 366.855 513.928C366.637 517.706 369.21 520.947 372.603 521.166C375.995 521.386 378.922 518.502 379.14 514.724Z",
    fill: "url(#paint65_linear_942_3230)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M457.211 607.689C456.936 606.27 455.628 605.357 454.289 605.649C452.95 605.94 452.088 607.327 452.364 608.745L456.646 630.815C456.921 632.233 458.23 633.147 459.568 632.855C460.907 632.563 461.769 631.177 461.494 629.758L457.211 607.689Z",
    fill: "url(#paint66_linear_942_3230)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M429.076 594.33C431.637 591.695 436.216 598.936 439.391 609.123C442.567 619.311 438.904 624.083 435.509 622.02C432.113 619.956 427.587 595.859 429.076 594.33Z",
    fill: "url(#paint67_linear_942_3230)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M423.648 492.961C425.219 493.096 427.473 497.216 426.644 503.499C425.816 509.781 422.82 511.672 421.864 510.119C421.423 509.4 423.306 505.304 423.393 501.472C423.492 497.02 421.933 492.813 423.648 492.961Z",
    fill: "url(#paint68_linear_942_3230)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M151.919 484.56H54.6664C53.1814 484.56 51.9775 485.836 51.9775 487.409V487.415C51.9775 488.989 53.1814 490.265 54.6664 490.265H151.919C153.404 490.265 154.607 488.989 154.607 487.415V487.409C154.607 485.836 153.404 484.56 151.919 484.56Z",
    fill: "url(#paint69_linear_942_3230)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M661.897 245.553V270.117C661.914 272.513 661.234 274.857 659.95 276.829C652.272 288.749 624.108 288.749 616.429 276.829C615.145 274.857 614.466 272.513 614.482 270.117V251.633C614.482 245.304 612.11 239.234 607.887 234.759C603.663 230.283 597.935 227.769 591.963 227.769H653.703C658.582 231.042 661.897 236.557 661.897 245.553Z",
    fill: "url(#paint70_linear_942_3230)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M709.277 245.553V270.117C709.294 272.513 708.614 274.857 707.33 276.829C699.651 288.749 671.488 288.749 663.809 276.829C662.525 274.857 661.845 272.513 661.862 270.117V245.553C661.862 236.557 658.547 231.042 653.662 227.8H701.077C705.991 231.042 709.277 236.557 709.277 245.553Z",
    fill: "url(#paint71_linear_942_3230)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M756.729 245.553V270.117C756.746 272.513 756.066 274.857 754.782 276.829C747.098 288.749 718.94 288.749 711.261 276.829C709.975 274.858 709.293 272.514 709.308 270.117V245.553C709.308 236.557 705.994 231.042 701.108 227.8H748.529C753.408 231.042 756.729 236.557 756.729 245.553Z",
    fill: "url(#paint72_linear_942_3230)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M804.14 245.553V270.117C804.157 272.513 803.477 274.857 802.193 276.829C794.515 288.749 766.351 288.749 758.678 276.829C757.392 274.858 756.71 272.514 756.725 270.117V245.553C756.725 236.557 753.411 231.042 748.525 227.8H795.94C800.837 231.042 804.14 236.557 804.14 245.553Z",
    fill: "url(#paint73_linear_942_3230)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M758.446 277.025C757.626 275.783 757.036 274.387 756.707 272.911C756.386 274.384 755.806 275.78 754.998 277.025L754.517 276.682C755.766 274.761 756.43 272.48 756.417 270.148H756.997C756.982 272.481 757.646 274.762 758.898 276.682L758.446 277.025Z",
    fill: "url(#paint74_linear_942_3230)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M851.562 252.204V270.142C851.573 272.096 851.121 274.022 850.247 275.742C850.057 276.124 849.846 276.493 849.615 276.848C841.937 288.767 813.773 288.767 806.1 276.848C804.814 274.876 804.132 272.532 804.147 270.135V245.572C804.147 236.575 800.832 231.06 795.947 227.818H840.071C846.897 227.8 851.562 235.236 851.562 252.204Z",
    fill: "url(#paint75_linear_942_3230)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M850.535 277.161H849.058L849.371 276.682C849.595 276.336 849.8 275.978 849.985 275.607L850.53 274.52L850.535 277.161Z",
    fill: "url(#paint76_linear_942_3230)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_942_3230",
    x1: 768.118,
    y1: 370.295,
    x2: 391.288,
    y2: 588.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC709F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA7C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_942_3230",
    x1: 719.174,
    y1: 279.445,
    x2: 591.572,
    y2: 415.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC407A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_942_3230",
    x1: 852.437,
    y1: 220.523,
    x2: 707.025,
    y2: 413.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_942_3230",
    x1: 554.228,
    y1: 289.94,
    x2: 554.228,
    y2: 332.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51823B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_942_3230",
    x1: 808.814,
    y1: 289.94,
    x2: 808.814,
    y2: 332.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51823B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_942_3230",
    x1: 558.841,
    y1: 429.856,
    x2: 559.477,
    y2: 433.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_942_3230",
    x1: 534.704,
    y1: 426.159,
    x2: 532.98,
    y2: 428.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_942_3230",
    x1: 535.871,
    y1: 431.33,
    x2: 534.933,
    y2: 435.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_942_3230",
    x1: 559.992,
    y1: 434.29,
    x2: 559.24,
    y2: 438.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_942_3230",
    x1: 543.614,
    y1: 446.824,
    x2: 522.28,
    y2: 483.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_942_3230",
    x1: 568.186,
    y1: 437.225,
    x2: 551.559,
    y2: 479.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECDE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDC34D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_942_3230",
    x1: 374.614,
    y1: 471.037,
    x2: 268.318,
    y2: 317.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC407A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_942_3230",
    x1: 454.577,
    y1: 273.814,
    x2: 463.821,
    y2: 283.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_942_3230",
    x1: 342.206,
    y1: 273.734,
    x2: 455.47,
    y2: 273.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_942_3230",
    x1: 650.769,
    y1: 642.739,
    x2: 824.481,
    y2: 817.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF769F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EC6A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC407A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_942_3230",
    x1: 284.165,
    y1: 758.214,
    x2: 442.141,
    y2: 539.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B4C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC407A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_942_3230",
    x1: 499.54,
    y1: 9.29109,
    x2: 610.561,
    y2: 323.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC407A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_942_3230",
    x1: 773.778,
    y1: 106.288,
    x2: 785.051,
    y2: 142.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_942_3230",
    x1: 229.127,
    y1: 54.022,
    x2: 382.687,
    y2: 153.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC407A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F099B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_942_3230",
    x1: 320.086,
    y1: 688.28,
    x2: 324.431,
    y2: 712.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_942_3230",
    x1: 328.724,
    y1: 711.85,
    x2: 304.811,
    y2: 783.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_942_3230",
    x1: 153.016,
    y1: 674.844,
    x2: 186.852,
    y2: 772.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_942_3230",
    x1: 170.566,
    y1: 695.177,
    x2: 154.484,
    y2: 732.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_942_3230",
    x1: 172.159,
    y1: 694.938,
    x2: 162.473,
    y2: 713.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_942_3230",
    x1: 465.224,
    y1: 674.844,
    x2: 499.06,
    y2: 772.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_942_3230",
    x1: 482.764,
    y1: 695.177,
    x2: 466.681,
    y2: 732.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_942_3230",
    x1: 484.362,
    y1: 694.938,
    x2: 474.676,
    y2: 713.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_942_3230",
    x1: 97.7022,
    y1: 571.549,
    x2: 110.087,
    y2: 627.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_942_3230",
    x1: 91.6073,
    y1: 507.65,
    x2: 131.368,
    y2: 592.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_942_3230",
    x1: 87.2646,
    y1: 552.718,
    x2: 109.913,
    y2: 589.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_942_3230",
    x1: 421.728,
    y1: 496.909,
    x2: 410.875,
    y2: 513.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_942_3230",
    x1: 295.077,
    y1: 559.308,
    x2: 267.691,
    y2: 682.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_942_3230",
    x1: 338.258,
    y1: 634.952,
    x2: 297.95,
    y2: 741.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_942_3230",
    x1: 325.913,
    y1: 621.246,
    x2: 456.291,
    y2: 696.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_942_3230",
    x1: 434.468,
    y1: 604.18,
    x2: 438.342,
    y2: 645.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_942_3230",
    x1: 185.073,
    y1: 615.154,
    x2: 171.126,
    y2: 711.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_942_3230",
    x1: 223.996,
    y1: 551.38,
    x2: 226.442,
    y2: 592.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_942_3230",
    x1: 376.243,
    y1: 236.557,
    x2: 414.897,
    y2: 293.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_942_3230",
    x1: 394.906,
    y1: 260.58,
    x2: 419.492,
    y2: 289.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_942_3230",
    x1: 393.518,
    y1: 264.891,
    x2: 403.81,
    y2: 287.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_942_3230",
    x1: 399.188,
    y1: 288.737,
    x2: 412.256,
    y2: 305.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_942_3230",
    x1: 404.641,
    y1: 241.948,
    x2: 404.641,
    y2: 264.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_942_3230",
    x1: 393.037,
    y1: 241.948,
    x2: 393.037,
    y2: 264.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_942_3230",
    x1: 398.837,
    y1: 241.948,
    x2: 398.837,
    y2: 264.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_942_3230",
    x1: 762.566,
    y1: 59.6294,
    x2: 778.243,
    y2: 119.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_942_3230",
    x1: 769.838,
    y1: 103.623,
    x2: 803.309,
    y2: 139.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_942_3230",
    x1: 770.831,
    y1: 106.405,
    x2: 772.58,
    y2: 126.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_942_3230",
    x1: 769.414,
    y1: 80.3302,
    x2: 772.96,
    y2: 106.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_942_3230",
    x1: 768.638,
    y1: 92.8145,
    x2: 775.676,
    y2: 121.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_942_3230",
    x1: 694.062,
    y1: 450.564,
    x2: 615.62,
    y2: 658.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_942_3230",
    x1: 600.769,
    y1: 406.091,
    x2: 549.366,
    y2: 495.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_942_3230",
    x1: 594.413,
    y1: 220.934,
    x2: 565.693,
    y2: 257.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_942_3230",
    x1: 684.339,
    y1: 458.897,
    x2: 704.835,
    y2: 445.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_942_3230",
    x1: 738.165,
    y1: 436.193,
    x2: 669.071,
    y2: 498.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_942_3230",
    x1: 98.3635,
    y1: 461.323,
    x2: 110.972,
    y2: 509.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_942_3230",
    x1: 99.3329,
    y1: 525.704,
    x2: 112.055,
    y2: 551.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_942_3230",
    x1: 93.0916,
    y1: 534.345,
    x2: 118.179,
    y2: 570.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_942_3230",
    x1: 101.758,
    y1: 528.253,
    x2: 126.852,
    y2: 563.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_942_3230",
    x1: 336.991,
    y1: 678.646,
    x2: 341.398,
    y2: 695.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_942_3230",
    x1: 240.273,
    y1: 606.133,
    x2: 191.126,
    y2: 646.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_942_3230",
    x1: 241.969,
    y1: 608.183,
    x2: 192.821,
    y2: 648.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_942_3230",
    x1: 243.663,
    y1: 610.234,
    x2: 194.515,
    y2: 650.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_942_3230",
    x1: 443.554,
    y1: 649.537,
    x2: 469.513,
    y2: 685.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#308B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_942_3230",
    x1: 389.352,
    y1: 500.692,
    x2: 385.154,
    y2: 510.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_942_3230",
    x1: 378.52,
    y1: 504.26,
    x2: 384.117,
    y2: 515.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_942_3230",
    x1: 365.855,
    y1: 522.874,
    x2: 378.253,
    y2: 509.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_942_3230",
    x1: 460.977,
    y1: 612.047,
    x2: 454.913,
    y2: 627.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#654B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_942_3230",
    x1: 435.859,
    y1: 603.055,
    x2: 430.066,
    y2: 618.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_942_3230",
    x1: 433.199,
    y1: 487.538,
    x2: 418.055,
    y2: 507.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_942_3230",
    x1: 101.421,
    y1: 480.292,
    x2: 111.638,
    y2: 514.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_942_3230",
    x1: 644.205,
    y1: 227.394,
    x2: 600.941,
    y2: 280.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_942_3230",
    x1: 700.405,
    y1: 214.627,
    x2: 667.525,
    y2: 270.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_942_3230",
    x1: 744.525,
    y1: 235.181,
    x2: 700.445,
    y2: 276.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_942_3230",
    x1: 807.884,
    y1: 217.176,
    x2: 755.075,
    y2: 268.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_942_3230",
    x1: 756.8,
    y1: 277.247,
    x2: 755.858,
    y2: 270.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_942_3230",
    x1: 838.801,
    y1: 233.265,
    x2: 792.841,
    y2: 282.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_942_3230",
    x1: 849.962,
    y1: 277.234,
    x2: 849.617,
    y2: 274.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A651"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationStore);
export default __webpack_public_path__ + "static/media/illustration_store.3beb79d6e180fd8968678d2a189ea0b8.svg";
export { ForwardRef as ReactComponent };